import lt from './lt'
import en from './en'
import ru from './ru'
import ua from './ua'

export default { lt, en, ru, ua }
